var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "805px",
    height: "243px",
    viewBox: "0 0 805 243",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Stars") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "2.05522813%",
    y1: "49.9999957%",
    x2: "96.9696998%",
    y2: "49.8245624%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8A3C5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABE",
    offset: "3.19004245%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-17.0%",
    y: "-31.7%",
    width: "134.5%",
    height: "160.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "25.9799957%",
    x2: "99.999575%",
    y2: "30.6898005%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M46.492325,9.12904135 C48.2464961,5.07391322 52.9558636,3.20861899 57.0109918,4.9627901 L91.1042404,19.7108793 L127.63707,12.6016138 C129.550464,12.2292687 131.533972,12.568332 133.215034,13.5551174 C135.349126,14.807832 136.688128,16.8966568 137.060257,19.1614919 L144,10.6876268 L144,53.5688984 L157.881337,64.2598706 C159.769202,65.713806 160.906526,67.9299198 160.994491,70.3009151 L161,70.5980523 L161,93.5917853 C161,93.6149894 160.999899,93.6381934 160.999697,93.6613966 C160.961252,98.0795074 157.348499,101.629928 152.930389,101.591482 L106.95144,101.191385 C105.078829,101.17509 103.259844,101.816249 101.811346,103.003174 L78.8397549,121.826506 C78.4513808,122.144747 78.0339087,122.425718 77.5928641,122.665699 C73.7119034,124.77741 68.8538829,123.343151 66.7421715,119.46219 L56.1338757,99.9659754 C54.9763528,97.8386483 52.9174474,96.3502019 50.5344713,95.9179928 L6.57230361,87.9444128 C2.76680331,87.2541952 9.12021516e-15,83.9404259 0,80.0728384 L0,54.4395545 C2.68777725e-15,52.8144321 0.983234798,51.3508411 2.48773893,50.7364387 L46.3225746,32.8353739 L45.8370623,12.4961607 C45.8094546,11.3396114 46.0330141,10.1908333 46.492325,9.12904135 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.3%",
    y: "-7.1%",
    width: "110.6%",
    height: "114.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.917189,11.1261964 L127.231867,39.5508733 C126.976778,39.9854365 127.084873,40.5419118 127.484099,40.8493753 L158.639203,64.8434122 C159.076763,65.1803982 159.158294,65.8082919 158.821308,66.245852 C158.630127,66.4940915 158.333648,66.6383734 158.020334,66.635647 L104.415473,66.169191 C104.181397,66.1671541 103.954024,66.247299 103.772961,66.3956646 L74.1664582,90.6557623 C72.8849004,91.7058937 70.994693,91.5182855 69.9445617,90.2367277 C69.8252215,90.0910875 69.7198575,89.9345354 69.6298644,89.7691437 L54.532051,62.0219714 C54.3873606,61.7560555 54.1299974,61.5699997 53.8321254,61.5159736 L3.37641741,52.3646363 C2.8329986,52.2660744 2.4723708,51.7456463 2.57093267,51.2022274 C2.63192358,50.8659553 2.86042143,50.5841175 3.17681419,50.4549105 L45.6844763,33.0958306 C46.0686659,32.9389371 46.3160296,32.5610602 46.3061263,32.1461877 L45.5760588,1.56200424 C45.5628791,1.00987677 45.9997826,0.551604766 46.5519101,0.538425068 C46.6964787,0.534974105 46.840076,0.56291904 46.9728,0.620332907 L90.8200922,19.5878354 C91.0051905,19.6679054 91.2101735,19.690138 91.4081344,19.6516149 L142.863773,9.63838027 C143.405889,9.53288494 143.930881,9.8868355 144.036377,10.428951 C144.08292,10.6681251 144.040537,10.9160637 143.917189,11.1261964 Z",
    id: "path-6"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.3%",
    y: "-1.6%",
    width: "99.7%",
    height: "102.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -2,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-21.8%",
    y: "-40.5%",
    width: "144.0%",
    height: "177.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "26.9330063%",
    x2: "99.999575%",
    y2: "31.4559463%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.5925918,9.1291262 C38.3467629,5.07399806 43.0561304,3.20870381 47.1112586,4.96287489 L71.2989708,15.4260178 L96.1068493,10.5984205 C98.0202425,10.2260754 100.003751,10.5651387 101.684813,11.5519241 C103.80757,12.7979849 105.14366,14.8712976 105.524024,17.1222247 L112.695648,8.36434221 L112.695,41.9229871 L122.881337,49.768308 C124.769202,51.2222434 125.906526,53.4383572 125.994491,55.8093526 L126,56.1064897 L126,71.4915267 C126,71.5147308 125.999899,71.5379348 125.999697,71.561138 C125.961252,75.9792487 122.348499,79.5296691 117.930389,79.4912238 L84.3311806,79.1988519 C82.45857,79.1825569 80.6395845,79.8237161 79.1910868,81.0106409 L63.3261722,94.0106353 C62.9377982,94.3288758 62.520326,94.6098464 62.0792815,94.8498279 C58.1983208,96.9615393 53.3403003,95.5272795 51.2285889,91.6463188 L44.3288282,78.9657511 C43.1713053,76.8384241 41.1123998,75.3499776 38.7294237,74.9177685 L6.57230363,69.0853135 C2.76680332,68.3950959 -2.96146487e-15,65.0813266 0,61.2137391 L0,45.8763358 C-1.28621862e-15,42.626091 1.96646961,39.698909 4.97547789,38.4701043 L36.2524497,25.6973612 L35.9373291,12.4962456 C35.9097214,11.3396962 36.1332809,10.1909181 36.5925918,9.1291262 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.7%",
    y: "-9.3%",
    width: "113.5%",
    height: "118.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-12"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.387164,9.12291821 L99.6700034,30.7875397 C99.4149142,31.2221029 99.5230086,31.7785781 99.9222352,32.0860417 L123.639399,50.3517646 C124.076959,50.6887506 124.15849,51.3166444 123.821504,51.7542045 C123.630323,52.0024439 123.333844,52.1467259 123.02053,52.1439995 L81.7954101,51.7852689 C81.5613338,51.783232 81.3339606,51.8633769 81.1528984,52.0117425 L58.6530717,70.4485023 C57.371514,71.4986336 55.4813065,71.3110254 54.4311752,70.0294676 C54.311835,69.8838274 54.206471,69.7272753 54.116478,69.5618836 L42.7271996,48.6303583 C42.5825092,48.3644424 42.325146,48.1783866 42.027274,48.1243604 L3.37661366,41.1141481 C2.83319485,41.0155862 2.47256704,40.4951581 2.57112891,39.9517393 C2.63211982,39.6154672 2.86061767,39.3336294 3.17701044,39.2044224 L35.6145476,25.9577331 C35.9987371,25.8008396 36.2461008,25.4229626 36.2361975,25.0080902 L35.6765218,1.56200423 C35.6633421,1.00987676 36.1002456,0.551604758 36.6523731,0.53842506 C36.7969418,0.534974097 36.940539,0.562919031 37.073263,0.620332897 L71.0150188,15.302889 C71.200117,15.382959 71.4051,15.4051916 71.6030609,15.3666685 L111.333749,7.63510206 C111.875864,7.52960673 112.400856,7.88355729 112.506352,8.42567276 C112.552895,8.6648469 112.510512,8.91278549 112.387164,9.12291821 Z",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.8%",
    y: "-1.3%",
    width: "98.8%",
    height: "101.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-14"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-21.8%",
    y: "-40.5%",
    width: "144.0%",
    height: "177.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.5925918,9.1291262 C38.3467629,5.07399806 43.0561304,3.20870381 47.1112586,4.96287489 L71.2989708,15.4260178 L96.1068493,10.5984205 C98.0202425,10.2260754 100.003751,10.5651387 101.684813,11.5519241 C103.80757,12.7979849 105.14366,14.8712976 105.524024,17.1222247 L112.695648,8.36434221 L112.695,41.9229871 L122.881337,49.768308 C124.769202,51.2222434 125.906526,53.4383572 125.994491,55.8093526 L126,56.1064897 L126,71.4915267 C126,71.5147308 125.999899,71.5379348 125.999697,71.561138 C125.961252,75.9792487 122.348499,79.5296691 117.930389,79.4912238 L84.3311806,79.1988519 C82.45857,79.1825569 80.6395845,79.8237161 79.1910868,81.0106409 L63.3261722,94.0106353 C62.9377982,94.3288758 62.520326,94.6098464 62.0792815,94.8498279 C58.1983208,96.9615393 53.3403003,95.5272795 51.2285889,91.6463188 L44.3288282,78.9657511 C43.1713053,76.8384241 41.1123998,75.3499776 38.7294237,74.9177685 L6.57230363,69.0853135 C2.76680332,68.3950959 -2.96146487e-15,65.0813266 0,61.2137391 L0,45.8763358 C-1.28621862e-15,42.626091 1.96646961,39.698909 4.97547789,38.4701043 L36.2524497,25.6973612 L35.9373291,12.4962456 C35.9097214,11.3396962 36.1332809,10.1909181 36.5925918,9.1291262 Z",
    id: "path-16"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.7%",
    y: "-9.3%",
    width: "113.5%",
    height: "118.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-17"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M112.387164,9.12291821 L99.6700034,30.7875397 C99.4149142,31.2221029 99.5230086,31.7785781 99.9222352,32.0860417 L123.639399,50.3517646 C124.076959,50.6887506 124.15849,51.3166444 123.821504,51.7542045 C123.630323,52.0024439 123.333844,52.1467259 123.02053,52.1439995 L81.7954101,51.7852689 C81.5613338,51.783232 81.3339606,51.8633769 81.1528984,52.0117425 L58.6530717,70.4485023 C57.371514,71.4986336 55.4813065,71.3110254 54.4311752,70.0294676 C54.311835,69.8838274 54.206471,69.7272753 54.116478,69.5618836 L42.7271996,48.6303583 C42.5825092,48.3644424 42.325146,48.1783866 42.027274,48.1243604 L3.37661366,41.1141481 C2.83319485,41.0155862 2.47256704,40.4951581 2.57112891,39.9517393 C2.63211982,39.6154672 2.86061767,39.3336294 3.17701044,39.2044224 L35.6145476,25.9577331 C35.9987371,25.8008396 36.2461008,25.4229626 36.2361975,25.0080902 L35.6765218,1.56200423 C35.6633421,1.00987676 36.1002456,0.551604758 36.6523731,0.53842506 C36.7969418,0.534974097 36.940539,0.562919031 37.073263,0.620332897 L71.0150188,15.302889 C71.200117,15.382959 71.4051,15.4051916 71.6030609,15.3666685 L111.333749,7.63510206 C111.875864,7.52960673 112.400856,7.88355729 112.506352,8.42567276 C112.552895,8.6648469 112.510512,8.91278549 112.387164,9.12291821 Z",
    id: "path-18"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "0.8%",
    y: "-1.3%",
    width: "98.8%",
    height: "101.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-19"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-20"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-26.5%",
    y: "-49.3%",
    width: "153.6%",
    height: "194.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-21"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "27.5418723%",
    x2: "99.999575%",
    y2: "31.9454268%",
    id: "linearGradient-22"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.2260916,9.12919774 C31.9802627,5.07406963 36.6896303,3.20877548 40.7447584,4.96294665 L58.5620558,12.6703701 L75.8294259,9.31015043 C77.7428184,8.93780541 79.7263266,9.27686834 81.4073881,10.2636531 C83.5231427,11.505603 84.8574129,13.5693563 85.2428056,15.8116832 L92.5635149,6.87012005 L92.5631814,34.4340582 L100.37244,40.4485608 C102.260305,41.9024962 103.397628,44.11861 103.485594,46.4896053 L103.491102,46.7867424 L103.490875,59.348191 C103.462041,62.6617741 100.752476,65.3245891 97.4388934,65.2957548 L69.7838977,65.0551054 C67.9112864,65.0388102 66.0923002,65.6799696 64.6438022,66.8668951 L52.4146536,76.8876808 C52.0748262,77.1661416 51.7095377,77.411991 51.3236235,77.621975 C47.9277829,79.4697225 43.6770149,78.2147451 41.8292674,74.8189046 L36.7369893,65.4601773 C35.5794663,63.3328501 33.5205606,61.8444036 31.1375843,61.4121946 L4.9294095,56.6587233 C2.0752841,56.1410602 0.000181419033,53.6557332 0.000181419033,50.7550424 L0.000181419033,38.6410329 C0.000181419033,35.390788 1.96665108,32.4636059 4.97565941,31.2348013 L29.7763674,21.1068048 L29.5708288,12.4963171 C29.5432211,11.3397677 29.7667806,10.1909896 30.2260916,9.12919774 Z",
    id: "path-23"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.2%",
    y: "-11.4%",
    width: "116.4%",
    height: "122.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-24"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.1093608,7.83457674 L81.9441904,25.1516943 C81.6891012,25.5862575 81.7971956,26.1427328 82.1964222,26.4501963 L101.130123,41.0319455 C101.567684,41.3689315 101.649215,41.9968252 101.312229,42.4343853 C101.121048,42.6826248 100.824569,42.8269067 100.511255,42.8241803 L67.2477511,42.5347297 C67.0136747,42.5326928 66.7863016,42.6128377 66.6052394,42.7612033 L48.6758338,57.4528778 C47.3942761,58.5030091 45.5040686,58.3154009 44.4539373,57.0338431 C44.3345972,56.8882029 44.2292332,56.7316509 44.1392402,56.5662592 L35.134982,40.0179894 C34.9902916,39.7520736 34.7329285,39.5660178 34.4350565,39.5119916 L3.37641758,33.8787724 C2.83299877,33.7802105 2.47237096,33.2597823 2.57093282,32.7163635 C2.63192373,32.3800914 2.86042159,32.0982536 3.17681437,31.9690466 L29.1380875,21.367104 C29.522277,21.2102105 29.7696407,20.8323336 29.7597374,20.4174611 L29.3096435,1.56200421 C29.2964638,1.00987674 29.7333673,0.551604737 30.2854947,0.538425039 C30.4300634,0.534974076 30.5736606,0.562919008 30.7063846,0.620332871 L58.2777261,12.5471688 C58.4628243,12.6272388 58.6678073,12.6494714 58.8657682,12.6109483 L91.0559456,6.34676056 C91.5980611,6.24126524 92.1230534,6.59521581 92.2285487,7.13733128 C92.2750918,7.37650542 92.2327089,7.62444401 92.1093608,7.83457674 Z",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "1.0%",
    y: "-1.6%",
    width: "98.5%",
    height: "101.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-26"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-26.5%",
    y: "-49.3%",
    width: "153.6%",
    height: "194.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-27"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.2260916,9.12919774 C31.9802627,5.07406963 36.6896303,3.20877548 40.7447584,4.96294665 L58.5620558,12.6703701 L75.8294259,9.31015043 C77.7428184,8.93780541 79.7263266,9.27686834 81.4073881,10.2636531 C83.5231427,11.505603 84.8574129,13.5693563 85.2428056,15.8116832 L92.5635149,6.87012005 L92.5631814,34.4340582 L101.931771,41.6494766 C102.85358,42.359406 103.417503,43.4327703 103.484393,44.586775 L103.491102,44.8185674 L103.490875,59.348191 C103.462041,62.6617741 100.752476,65.3245891 97.4388934,65.2957548 L69.7838977,65.0551054 C67.9112864,65.0388102 66.0923002,65.6799696 64.6438022,66.8668951 L52.4146536,76.8876808 C52.0748262,77.1661416 51.7095377,77.411991 51.3236235,77.621975 C47.9277829,79.4697225 43.6770149,78.2147451 41.8292674,74.8189046 L36.7369893,65.4601773 C35.5794663,63.3328501 33.5205606,61.8444036 31.1375843,61.4121946 L4.9294095,56.6587233 C2.0752841,56.1410602 0.000181419033,53.6557332 0.000181419033,50.7550424 L0.000181419033,35.9538482 C0.000181419033,34.3287258 0.983416249,32.8651347 2.48792041,32.2507324 L29.7763674,21.1068048 L29.5708288,12.4963171 C29.5432211,11.3397677 29.7667806,10.1909896 30.2260916,9.12919774 Z",
    id: "path-28"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-8.2%",
    y: "-11.4%",
    width: "116.4%",
    height: "122.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-29"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M92.1093608,7.83457674 L81.9441904,25.1516943 C81.6891012,25.5862575 81.7971956,26.1427328 82.1964222,26.4501963 L101.130123,41.0319455 C101.567684,41.3689315 101.649215,41.9968252 101.312229,42.4343853 C101.121048,42.6826248 100.824569,42.8269067 100.511255,42.8241803 L67.2477511,42.5347297 C67.0136747,42.5326928 66.7863016,42.6128377 66.6052394,42.7612033 L48.6758338,57.4528778 C47.3942761,58.5030091 45.5040686,58.3154009 44.4539373,57.0338431 C44.3345972,56.8882029 44.2292332,56.7316509 44.1392402,56.5662592 L35.134982,40.0179894 C34.9902916,39.7520736 34.7329285,39.5660178 34.4350565,39.5119916 L3.37641758,33.8787724 C2.83299877,33.7802105 2.47237096,33.2597823 2.57093282,32.7163635 C2.63192373,32.3800914 2.86042159,32.0982536 3.17681437,31.9690466 L29.1380875,21.367104 C29.522277,21.2102105 29.7696407,20.8323336 29.7597374,20.4174611 L29.3096435,1.56200421 C29.2964638,1.00987674 29.7333673,0.551604737 30.2854947,0.538425039 C30.4300634,0.534974076 30.5736606,0.562919008 30.7063846,0.620332871 L58.2777261,12.5471688 C58.4628243,12.6272388 58.6678073,12.6494714 58.8657682,12.6109483 L91.0559456,6.34676056 C91.5980611,6.24126524 92.1230534,6.59521581 92.2285487,7.13733128 C92.2750918,7.37650542 92.2327089,7.62444401 92.1093608,7.83457674 Z",
    id: "path-30"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "1.0%",
    y: "-1.6%",
    width: "98.5%",
    height: "101.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-31"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stars",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-100",
    transform: "translate(17.000147, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star",
    transform: "translate(304.530127, 91.731445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.917189,50.1261964 L127.231867,78.5508733 C126.976778,78.9854365 127.084873,79.5419118 127.484099,79.8493753 L158.639203,103.843412 C159.076763,104.180398 159.158294,104.808292 158.821308,105.245852 C158.630127,105.494091 158.333648,105.638373 158.020334,105.635647 L104.415473,105.169191 C104.181397,105.167154 103.954024,105.247299 103.772961,105.395665 L76.9704362,127.358133 C74.4073207,129.458395 70.6269058,129.083179 68.5266432,126.520063 C68.2879627,126.228783 68.0772348,125.915679 67.8972487,125.584895 L54.532051,101.021971 C54.3873606,100.756056 54.1299974,100.57 53.8321254,100.515974 L3.37641741,91.3646363 C2.8329986,91.2660744 2.4723708,90.7456463 2.57093267,90.2022274 C2.63192358,89.8659553 2.86042143,89.5841175 3.17681419,89.4549105 L45.6844763,72.0958306 C46.0686659,71.9389371 46.3160296,71.5610602 46.3061263,71.1461877 L45.5760588,40.5620042 C45.5628791,40.0098768 45.9997826,39.5516048 46.5519101,39.5384251 C46.6964787,39.5349741 46.840076,39.562919 46.9728,39.6203329 L90.8200922,58.5878354 C91.0051905,58.6679054 91.2101735,58.690138 91.4081344,58.6516149 L142.863773,48.6383803 C143.405889,48.5328849 143.930881,48.8868355 144.036377,49.428951 C144.08292,49.6681251 144.040537,49.9160637 143.917189,50.1261964 Z",
    id: "Vector",
    fill: "url(#linearGradient-1)",
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-3)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star",
    transform: "translate(515.049658, 67.671631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.387212,39.1229182 L99.6700513,60.7875397 C99.4149622,61.2221029 99.5230565,61.7785781 99.9222831,62.0860417 L123.639447,80.3517646 C124.077007,80.6887506 124.158538,81.3166444 123.821552,81.7542045 C123.630371,82.0024439 123.333892,82.1467259 123.020578,82.1439995 L81.7954581,81.7852689 C81.5613818,81.783232 81.3340086,81.8633769 81.1529463,82.0117425 L61.4570976,98.1508726 C58.8939822,100.251135 55.1135673,99.8759188 53.0133047,97.3128033 C52.7746242,97.0215228 52.5638963,96.7084187 52.3839102,96.3776353 L42.7272475,78.6303583 C42.5825572,78.3644424 42.325194,78.1783866 42.027322,78.1243604 L3.3766616,71.1141481 C2.83324279,71.0155862 2.47261498,70.4951581 2.57117685,69.9517393 C2.63216776,69.6154672 2.86066562,69.3336294 3.17705838,69.2044224 L35.6145955,55.9577331 C35.9987851,55.8008396 36.2461488,55.4229626 36.2362455,55.0080902 L35.6765698,31.5620042 C35.6633901,31.0098768 36.1002936,30.5516048 36.652421,30.5384251 C36.7969897,30.5349741 36.940587,30.562919 37.0733109,30.6203329 L71.0150667,45.302889 C71.200165,45.382959 71.4051479,45.4051916 71.6031089,45.3666685 L111.333797,37.6351021 C111.875912,37.5296067 112.400904,37.8835573 112.5064,38.4256728 C112.552943,38.6648469 112.51056,38.9127855 112.387212,39.1229182 Z",
    id: "Glow",
    fill: "url(#linearGradient-8)",
    filter: "url(#filter-9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-10)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-12)",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    xlinkHref: "#path-13"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-14)",
    xlinkHref: "#path-13"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star",
    transform: "translate(129.010595, 67.671631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.387212,40.1229182 L99.6700513,61.7875397 C99.4149622,62.2221029 99.5230565,62.7785781 99.9222831,63.0860417 L123.639447,81.3517646 C124.077007,81.6887506 124.158538,82.3166444 123.821552,82.7542045 C123.630371,83.0024439 123.333892,83.1467259 123.020578,83.1439995 L81.7954581,82.7852689 C81.5613818,82.783232 81.3340086,82.8633769 81.1529463,83.0117425 L61.4570976,99.1508726 C58.8939822,101.251135 55.1135673,100.875919 53.0133047,98.3128033 C52.7746242,98.0215228 52.5638963,97.7084187 52.3839102,97.3776353 L42.7272475,79.6303583 C42.5825572,79.3644424 42.325194,79.1783866 42.027322,79.1243604 L3.3766616,72.1141481 C2.83324279,72.0155862 2.47261498,71.4951581 2.57117685,70.9517393 C2.63216776,70.6154672 2.86066562,70.3336294 3.17705838,70.2044224 L35.6145955,56.9577331 C35.9987851,56.8008396 36.2461488,56.4229626 36.2362455,56.0080902 L35.6765698,32.5620042 C35.6633901,32.0098768 36.1002936,31.5516048 36.652421,31.5384251 C36.7969897,31.5349741 36.940587,31.562919 37.0733109,31.6203329 L71.0150667,46.302889 C71.200165,46.382959 71.4051479,46.4051916 71.6031089,46.3666685 L111.333797,38.6351021 C111.875912,38.5296067 112.400904,38.8835573 112.5064,39.4256728 C112.552943,39.6648469 112.51056,39.9127855 112.387212,40.1229182 Z",
    id: "Glow",
    fill: "url(#linearGradient-8)",
    filter: "url(#filter-15)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-10)",
    xlinkHref: "#path-16"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-17)",
    xlinkHref: "#path-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-8)",
    xlinkHref: "#path-18"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-19)",
    xlinkHref: "#path-18"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star",
    transform: "translate(666.569336, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1094581,31.8345767 L81.9442878,49.1516943 C81.6891986,49.5862575 81.797293,50.1427328 82.1965196,50.4501963 L101.130221,65.0319455 C101.567781,65.3689315 101.649312,65.9968252 101.312326,66.4343853 C101.121145,66.6826248 100.824666,66.8269067 100.511352,66.8241803 L67.2478485,66.5347297 C67.0137721,66.5326928 66.7863989,66.6128377 66.6053367,66.7612033 L51.4799092,79.1552483 C48.9167936,81.2555109 45.1363788,80.8802944 43.0361162,78.3171789 C42.7974358,78.0258984 42.5867079,77.7127944 42.4067218,77.382011 L35.1350794,64.0179894 C34.990389,63.7520736 34.7330259,63.5660178 34.4351538,63.5119916 L3.37651497,57.8787724 C2.83309616,57.7802105 2.47246835,57.2597823 2.57103021,56.7163635 C2.63202112,56.3800914 2.86051898,56.0982536 3.17691176,55.9690466 L29.1381848,45.367104 C29.5223744,45.2102105 29.7697381,44.8323336 29.7598348,44.4174611 L29.3097409,25.5620042 C29.2965612,25.0098767 29.7334646,24.5516047 30.2855921,24.538425 C30.4301608,24.5349741 30.573758,24.562919 30.706482,24.6203329 L58.2778234,36.5471688 C58.4629217,36.6272388 58.6679047,36.6494714 58.8658656,36.6109483 L91.056043,30.3467606 C91.5981585,30.2412652 92.1231508,30.5952158 92.2286461,31.1373313 C92.2751892,31.3765054 92.2328063,31.624444 92.1094581,31.8345767 Z",
    id: "Glow",
    fill: "url(#linearGradient-20)",
    filter: "url(#filter-21)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-22)",
    xlinkHref: "#path-23"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-24)",
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-20)",
    xlinkHref: "#path-25"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-26)",
    xlinkHref: "#path-25"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Star"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.1094581,32.8345767 L81.9442878,50.1516943 C81.6891986,50.5862575 81.797293,51.1427328 82.1965196,51.4501963 L101.130221,66.0319455 C101.567781,66.3689315 101.649312,66.9968252 101.312326,67.4343853 C101.121145,67.6826248 100.824666,67.8269067 100.511352,67.8241803 L67.2478485,67.5347297 C67.0137721,67.5326928 66.7863989,67.6128377 66.6053367,67.7612033 L51.4799092,80.1552483 C48.9167936,82.2555109 45.1363788,81.8802944 43.0361162,79.3171789 C42.7974358,79.0258984 42.5867079,78.7127944 42.4067218,78.382011 L35.1350794,65.0179894 C34.990389,64.7520736 34.7330259,64.5660178 34.4351538,64.5119916 L3.37651497,58.8787724 C2.83309616,58.7802105 2.47246835,58.2597823 2.57103021,57.7163635 C2.63202112,57.3800914 2.86051898,57.0982536 3.17691176,56.9690466 L29.1381848,46.367104 C29.5223744,46.2102105 29.7697381,45.8323336 29.7598348,45.4174611 L29.3097409,26.5620042 C29.2965612,26.0098767 29.7334646,25.5516047 30.2855921,25.538425 C30.4301608,25.5349741 30.573758,25.562919 30.706482,25.6203329 L58.2778234,37.5471688 C58.4629217,37.6272388 58.6679047,37.6494714 58.8658656,37.6109483 L91.056043,31.3467606 C91.5981585,31.2412652 92.1231508,31.5952158 92.2286461,32.1373313 C92.2751892,32.3765054 92.2328063,32.624444 92.1094581,32.8345767 Z",
    id: "Vector",
    fill: "url(#linearGradient-20)",
    filter: "url(#filter-27)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-22)",
    xlinkHref: "#path-28"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-29)",
    xlinkHref: "#path-28"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-20)",
    xlinkHref: "#path-30"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-31)",
    xlinkHref: "#path-30"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/Stars.a298928acf362dc14070cd053659cab7.svg";
export { ForwardRef as ReactComponent };